import { Link } from 'react-router-dom';

interface VideoCardProps {
  id: string;
  title: string;
  description: string;
  imageUrl: string;
  rating: number;
  year: string;
  duration: string;
  quality: string;
  views: number;
  isHot: boolean;
  isNew: boolean;
  isVip: boolean;
  slug: string;
  category: string;
}

export default function VideoCard({
  title,
  description,
  imageUrl,
  rating,
  year,
  duration,
  quality,
  views,
  isHot,
  isNew,
  isVip,
  slug,
}: VideoCardProps) {
  const formattedViews = views >= 10000 ? `${(views / 10000).toFixed(1)}万` : views.toString();

  return (
    <Link
      to={`/article/${slug}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
        <img
          src={imageUrl}
          alt={title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
          title={title}
        />
        <div className="absolute top-2 left-2 flex items-center gap-1">
          {isNew && (
            <span className="px-1.5 py-0.5 text-[10px] font-medium bg-primary-500 text-background-50 dark:text-foreground-950 rounded whitespace-nowrap">
              新
            </span>
          )}
          {isHot && (
            <span className="px-1.5 py-0.5 text-[10px] font-medium bg-accent-500 text-background-50 dark:text-foreground-950 rounded whitespace-nowrap">
              热
            </span>
          )}
        </div>
        <div className="absolute top-2 right-2">
          <span className="px-1.5 py-0.5 text-[10px] font-medium bg-foreground-800/80 text-background-50 rounded whitespace-nowrap">
            {quality}
          </span>
        </div>
        {isVip && (
          <div className="absolute bottom-2 left-2">
            <span className="px-1.5 py-0.5 text-[10px] font-medium bg-accent-500/90 text-foreground-950 rounded whitespace-nowrap">
              VIP
            </span>
          </div>
        )}
        <div className="absolute bottom-2 right-2 flex items-center gap-1">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-star-fill text-accent-400 text-xs"></i>
          </div>
          <span className="text-xs text-background-50 font-medium">{rating}</span>
        </div>
      </div>

      <h3 className="text-sm font-medium text-foreground-950 line-clamp-2 leading-snug mb-1 group-hover:text-primary-500 transition-colors">
        {title}
      </h3>

      <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed mb-2">
        {description}
      </p>

      <div className="flex items-center gap-3 text-[11px] text-foreground-400">
        <span>{year}</span>
        <span className="w-0.5 h-0.5 rounded-full bg-foreground-300"></span>
        <span>{duration}</span>
        <span className="w-0.5 h-0.5 rounded-full bg-foreground-300"></span>
        <span>{formattedViews}次播放</span>
      </div>
    </Link>
  );
}